/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useEffect } from 'react';
import { Redirect } from 'react-router';

import { Box, Loader, Text } from '@opendoor/bricks/core';

import { EXP_IDENTIFIER_PRODUCTION, ZILLOW_IDENTIFIER_PRODUCTION } from '../../src/constants';
import { ERROR_PAGE_ROUTE } from '../../src/routes/routes';

// This welcome redirect page is for the partner <> opendoor direct handoff experience
const WelcomeRedirectPage: React.FC<unknown> = () => {
  const redirectURI = new URLSearchParams(window.location.search).get('redirect_uri');
  const partnerIdentifier = new URLSearchParams(window.location.search).get('partner');

  // since this should only go to the dashboard, host should limited to consumer.x pages
  const allowedHostNames = ['consumer.simplersell.com', 'consumer.opendoor.com'];
  useEffect(() => {
    if (
      redirectURI &&
      new URL(redirectURI) &&
      allowedHostNames.includes(new URL(redirectURI).hostname)
    ) {
      setTimeout(() => {
        return window.location.replace(redirectURI!);
      }, 2000);
    }
  }, [redirectURI, allowedHostNames]);
  if (
    !redirectURI ||
    !new URL(redirectURI) ||
    !allowedHostNames.includes(new URL(redirectURI).hostname)
  ) {
    return <Redirect to={ERROR_PAGE_ROUTE} />;
  }

  interface RedirectTextMap {
    [key: string]: string;
  }

  const redirectTextMap: RedirectTextMap = {
    //partner identifier to redirect text mapping
    [ZILLOW_IDENTIFIER_PRODUCTION]: "You're leaving Zillow and going to Opendoor",
    [EXP_IDENTIFIER_PRODUCTION]: 'Redirecting you to Opendoor for Agents to finalize your offer',
  };
  const redirectText = partnerIdentifier
    ? redirectTextMap[partnerIdentifier]
    : 'Redirecting you to Opendoor to finalize your offer';

  return (
    <Box
      marginX="auto"
      maxWidth="600px"
      textAlign="center"
      display="flex"
      flexDirection="column"
      position="absolute"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      gridGap="9"
      style={{ backgroundColor: 'FF0000' }}
    >
      <Loader shade="dark" padding="none" size={45} />

      <img
        alt="Opendoor"
        height="100%"
        src="https://imgdrop.imgix.net/2024-02-1707779067635-59949.svg"
      />
      <Text size="s2" fontWeight="medium">
        {redirectText}
      </Text>
    </Box>
  );
};

export default WelcomeRedirectPage;
